import React from 'react';
import PropTypes from 'prop-types';
import { useConfig } from '@mulesoft/exchange-react-hooks';
import { VersionsTable as GenericAssetPortalVersionsTable } from '@mulesoft/exchange-ui-portals-common';

const AssetPortalVersionsTable = ({ portalConfiguration, ...props }) => {
  const config = useConfig();
  const metadata = portalConfiguration.metadata({
    ...props,
    config,
    section: 'versions-table'
  });
  const headers = () => metadata;

  return (
    <GenericAssetPortalVersionsTable {...props} additionalHeaders={headers} />
  );
};

AssetPortalVersionsTable.propTypes = {
  portalConfiguration: PropTypes.object
};

export default AssetPortalVersionsTable;
